import { CurrencySymbolPipe } from './currency-symbol.pipe';

export const CURRENCY_SYMBOL_DECLARATIONS = [CurrencySymbolPipe];

export * from './currency-symbol.pipe';
